import { type BlockContent } from '@/types/content'

export const versionOperator2ChangeSymbol = {
  '+': 'add',
  '~': 'replace',
  '-': 'remove',
} as const

type VersionOperation =
  (typeof versionOperator2ChangeSymbol)[keyof typeof versionOperator2ChangeSymbol]

export type Version = {
  id: number
  created_at: string
  user_id?: number
  user?: string
  meta_data: {
    initial_version?: boolean
    workflow_stage_id?: number
    release_name?: string
    automatically?: boolean
  }
  status:
    | 'draft'
    | 'published'
    | 'unpublished'
    | 'scheduled'
    | 'workflow_stage_changed'
    | 'release_scheduled'
  disabled?: boolean
  parent_id?: number | null
  release_id?: number
  releaseName?: string
  story_id?: number
  latestVersion?: boolean
  isOldVersion?: boolean
}

export type VersionWithContent = Version & {
  content: unknown
}

export type VersionListItem = Version & {
  children?: Version[]
}

export type VersionsResponse = {
  story_versions: Version[]
}

export type VersionsWithContentResponse = {
  story_versions: VersionWithContent[]
}

export type VersionsParams = {
  by_story_id?: number
  by_release_id?: number
  page?: number
  per_page?: number
}

// this type refers to the type of values we get from the API as the very last leaf of an object property or array element
export type LastLeafAllowedType = string | number | boolean | undefined

export type Change = {
  operation: VersionOperation
  field: string
  previousValue: LastLeafAllowedType
  nextValue: LastLeafAllowedType
}

export type ComparisonParams = {
  release_id?: number
  version_v2?: number
  from_version_v2?: number
  version?: number
  from_version?: number
  legacy?: boolean
}

export type ComparisonResponse = { changes: Change[]; full: BlockContent }
export type ComparisonResponseLegacy = ['+' | '~' | '-', string, string, string]

export type VersionLegacy = {
  id: number
  event: string
  created_at: string
  author_id: string
  author: string
  item_id: number
  is_draft: boolean
}

export type VersionsResponseLegacy = {
  versions: VersionLegacy[]
}
